export default __webpack_public_path__ + "static/media/sabc.1a74651d.png";